import React, { FC, useState } from 'react'

import { Wrapper } from 'components/page/ForeignProfile/Field/Field.styled'
import { addHighlightedItem } from 'components/page/ForeignProfile/Field/Interests/function/addHighlightedItem'
import { GQLForeignRootQuery } from 'components/page/ForeignProfile/gql/__generated__/ForeignRoot'
import { interestsPath } from 'components/page/Interests/Interests.paths'
import { ParentIconBlueHashTag } from 'components/page/Interests/InterestsIcon.styled'
import { InterestsListLoadable } from 'components/page/Interests/InterestsListLoadable'
import { ShowMoreInterest } from 'components/page/Interests/ShowMoreInterest'
import { GenericMenuItemIndex } from 'components/presentational/GenericMenuItemIndex/GenericMenuItemIndex'
import { HashTagActiveSvg } from 'components/presentational/svg/HashTagActiveSvg'
import { ListInterest } from 'reducers/interests/interests.types'

export const InterestsView: FC<{
  data: NonNullable<
    GQLForeignRootQuery['user']
  >['interests']['interests']['nodes']
  dataCurrentUser: NonNullable<
    GQLForeignRootQuery['my']
  >['interests']['interests']['nodes']
  count: number
  onSaveInterestSearch: (id: number) => void
}> = ({ data, dataCurrentUser, count, onSaveInterestSearch }) => {
  const [isShowAll, setShowAll] = useState(false)
  const interestList = addHighlightedItem(data, dataCurrentUser)

  return (
    <Wrapper>
      <GenericMenuItemIndex
        data-name={`profile-${interestsPath}`}
        hideArrow={true}
        active={true}
        label={false}
        iconItem={
          <ParentIconBlueHashTag>
            <HashTagActiveSvg />
          </ParentIconBlueHashTag>
        }
        style={{ padding: '0' }}
      >
        <InterestsListLoadable
          items={interestList}
          allHighlighted={false}
          isShowAllInterest={isShowAll}
          horizontalAlignment="flex-start"
          numberColumnToShow={4}
          showMore={
            <ShowMoreInterest onClick={() => setShowAll(true)} size={count} />
          }
          onClick={onSaveInterestSearch}
          type={ListInterest.interests}
        />
      </GenericMenuItemIndex>
    </Wrapper>
  )
}
